import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useLazyQuery } from '@apollo/react-hooks';
import { TestAudiencesBySpecs, TestAudiencesBySpecsVariables } from './__generated__/TestAudiencesBySpecs';

export const TEST_AUDIENCES_BY_SPECS = gql`
  query TestAudiencesBySpecs($articleId: ID!, $audiences: [AudiencesInput!]!) {
    testAudiencesBySpecs(articleId: $articleId, audiences: $audiences) {
      audienceSizeDescription
      errors
    }
  }
`;

export const useTestAudiencesBySpecsQuery = () => {
  return useLazyQuery<TestAudiencesBySpecs, TestAudiencesBySpecsVariables>(TEST_AUDIENCES_BY_SPECS, {
    client: kmsClient,
    fetchPolicy: 'no-cache'
  });
};
